import React, { isValidElement } from 'react';
import { arrayOf, bool, func, node, oneOf, oneOfType, shape, string } from 'prop-types';
import { cx } from '@emotion/css';

import { TabContainer, TabItem } from './style';

const Tab = (props) => {
  const { className, style, activeTab, setActiveTab, tabOptions, variant, size, ...rest } = props;

  const renderIcon = (icon, key) => {
    if (typeof icon === 'string') {
      return <img src={icon} alt={key} height={24} width={24} />;
    }
    if (isValidElement(icon)) {
      return icon;
    }
    return null;
  };

  return (
    <TabContainer className={className} style={style} variant={variant} size={size} {...rest}>
      {tabOptions.map(
        // If opt.show is true, show TabItem, if opt.show is false, hide TabItem
        // If opt.show is not specified, show by default
        (opt) =>
          opt.show !== false && (
            <TabItem
              key={opt.key}
              role="button"
              className={cx({ active: opt.key === activeTab?.key })}
              onClick={() => setActiveTab(opt)}
              variant={variant}
              size={size}
            >
              {opt.icon && renderIcon(opt.icon, opt.key)}
              {opt.name}
            </TabItem>
          )
      )}
    </TabContainer>
  );
};

const tabOptionPropType = shape({
  key: string,
  icon: oneOfType([node, string]),
  name: string,
  show: bool,
});

Tab.propTypes = {
  className: string,
  style: shape({}),
  activeTab: tabOptionPropType,
  setActiveTab: func,
  tabOptions: arrayOf(tabOptionPropType),
  variant: oneOf(['default', 'scoped']),
  size: oneOf(['sm', 'md', 'lg']),
};

Tab.defaultProps = {
  className: '',
  style: {},
  activeTab: {},
  setActiveTab: () => {},
  tabOptions: [],
  variant: 'default',
  size: 'sm',
};

export default Tab;
